import { TxResponse, SelectedCoinDenom } from '@/wallet-utils'
import { z } from 'zod'

export interface MetaDataHandlerParameters<T> {
  response: TxResponse
  message: T
  selectedAddress: string
  strideAddress: string
  dexAddress: string | null | undefined
  denom: SelectedCoinDenom
}

export interface MetaDataFactoryParameters<T> {
  response: TxResponse
  message: T
  strideAddress: string
  selectedAddress: string
  dexAddress: string | null | undefined
  denom: SelectedCoinDenom
}

export interface RedemptionMetaDataFactoryParameters {
  unbonding: z.infer<typeof unbondingSchema>
  selectedAddress: string
  denom: SelectedCoinDenom
}

export interface TiaRedemptionMetaDataFactoryParameters {
  payload: z.infer<typeof redemptionRecordPayloadSchema>
  selectedAddress: string
  strideAddress: string
  denom: SelectedCoinDenom
}

export interface DymRedemptionMetaDataFactoryParameters {
  payload: z.infer<typeof redemptionRecordPayloadSchema>
  selectedAddress: string
  strideAddress: string
  denom: SelectedCoinDenom
}

// For everything non-TIA
export const unbondingSchema = z.object({
  address: z.string(),
  receiver: z.string(),
  unbonding_estimated_time: z.string(),
  amount: z.string(),
  denom: z.string(),
  claim_is_pending: z.boolean(),
  epoch_number: z.string()
})

export const unbondingsResponseSchema = z.object({
  address_unbondings: z.array(unbondingSchema)
})

// for TIA
export const redemptionRecordPayloadSchema = z.object({
  redemption_record: z.object({
    unbonding_record_id: z.string(),
    redeemer: z.string(),
    st_token_amount: z.string(),
    native_amount: z.string()
  }),

  unbonding_completion_time_seconds: z.string()
})

export const redemptionRecordResponseSchema = z.object({
  redemption_record_responses: z.array(redemptionRecordPayloadSchema)
})
